import { Link } from 'react-router-dom'
import type { Project } from '../types'

interface ProjectCardProps {
  project: Project
}

export function ProjectCard({ project }: ProjectCardProps) {
  const timeAgo = getTimeAgo(new Date(project.updatedAt))

  return (
    <Link
      to={`/projects/${project.id}`}
      className="group relative aspect-[4/3] rounded-2xl overflow-hidden cursor-pointer shadow-card card-hover-premium bg-white"
    >
      {/* Background Image */}
      {project.coverImage ? (
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
          style={{ backgroundImage: `url("${project.coverImage}")` }}
          data-alt={project.name}
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-secondary/20 transition-transform duration-700 group-hover:scale-105" />
      )}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-80" />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-5 flex justify-between items-end">
        <div>
          <p className="text-white font-serif font-medium text-lg tracking-wide">
            {project.name}
          </p>
          <p className="text-white/80 text-xs mt-1 font-light">
            {project.imageCount} images • Updated {timeAgo}
          </p>
        </div>
      </div>
    </Link>
  )
}

function getTimeAgo(date: Date): string {
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMins / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffMins < 60) return `${diffMins}m ago`
  if (diffHours < 24) return `${diffHours}h ago`
  if (diffDays < 7) return `${diffDays}d ago`
  return date.toLocaleDateString()
}
